import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import IconButton from 'components/IconButton';
const CreditAlertContent = () => {
    const { session: { login } } = useSession();
    return login.hasClaim('signIn:apa') ? (_jsxs(_Fragment, { children: ["Sie haben nicht genug Guthaben. Wenden Sie sich bitte an APA-Salesdesk:", _jsx(IconButton, { onClick: () => {
                    window.location.href = 'mailto:salesdesk@apa.at';
                }, children: "salesdesk@apa.at" })] })) : (_jsxs("span", { children: [txt('notEnoughCredit'), ' '] }));
};
export default CreditAlertContent;
